import { api } from "shared/config/api/api";
import type {
  ForgotPasswordRequest,
  PasswordRecoveryMessage,
  ResetPasswordRequest,
} from "../model/types";

export const passwordRecoveryApi = api.injectEndpoints({
  endpoints: (builder) => ({
    forgotPassword: builder.mutation<
      PasswordRecoveryMessage,
      ForgotPasswordRequest
    >({
      query: (body) => ({
        url: "/auth/password/forgot",
        method: "POST",
        body,
      }),
    }),
    resetPassword: builder.mutation<
      PasswordRecoveryMessage,
      ResetPasswordRequest
    >({
      query: (body) => ({
        url: "/auth/password/reset",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useForgotPasswordMutation, useResetPasswordMutation } =
  passwordRecoveryApi;
